import Botao from '../Botao/Botao';
import Modal from '../Modal/Modal';
import { BotaoContainer, ModalContainerDelete } from './styles';

interface updateModalProps {
  isModalOpen: boolean;
  onUpDateClick?: any;
  onCloseModal: any;
}

const ModalDevolution = (props: updateModalProps): any => {
  const { isModalOpen, onUpDateClick, onCloseModal } = props;

  return (
    <Modal
      isOpen={isModalOpen}
      width={420}
      onClose={onCloseModal}
    >
      <>
        <ModalContainerDelete>
          <h1 className='texth1'>Atenção!</h1>
          <p className='textP'>Tem certeza que deseja deletar esse arquivo?</p>
          <BotaoContainer>
            <Botao
              tipo='salvar'
              tamanho="medio"
              className="btn"
              disabled={false}
              onClick={() => {
                onUpDateClick();
                setTimeout(() => {
                  onCloseModal()
                }, 100)
              }}
            >
              OK
            </Botao>
            <Botao
              tamanho="medio"
              className="btn"
              onClick={onCloseModal}
            >
              Cancelar
            </Botao>
          </BotaoContainer>
        </ModalContainerDelete>
      </>
    </Modal>
  );
};

export default ModalDevolution;
